module.exports = __webpack_public_path__ + "img/acacia-logo.7d4a72d9.svg";